export function isVideoDeviceOffline(patient) {
  return !patient.video_device || patient.video_device.status !== 'online'
}

export function isFixedDeviceOffline(patient) {
  return patient.video_device &&
         patient.video_device.kind === 'fixed' &&
         isVideoDeviceOffline(patient)
}

export function offlineDeviceTooltip(patient) {
  return {
    content: 'Video device is offline',
    disabled: !isVideoDeviceOffline(patient),
    placement: 'bottom'
  }
}